import React, { FC, useEffect, useRef, useState } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";

export const ADTouchLessWidget: FC<any> = () => {

    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/landing_pages/touchless/assets/main.us.js?v=2";
        script.defer = true;
        document.body.appendChild(script);
    }, []);


    return (
        <>
            <div id="adi-hero-holder"></div>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ADTouchLessWidget,
    definition: {
        group: "Common",
        displayName: "ADI Touchless",
        fieldDefinitions: [],
    },
};

export default widgetModule;
